const projects = [
  {
    id: 1,
    image: {
      src: '/projects/horushotel.png',
      alt: 'Horus Hotel',
    },
    description: [
      'Aplicacion Web usando Laravel y Ajax.',
      'Centrado en optimizar procesos de gestión humana: reclutamiento, clima laboral, evaluación de desempeño',
    ],
    link: {
      href: 'https://warihc.com/', //https://www.horus-sc.com
      isDisabled: false,
      textLink: 'www.warihc.com',
    },
  },
  {
    id: 2,
    image: {
      src: '/projects/shopylive.png',
      alt: 'Shopylive',
    },
    description: [
      'Aplicacion Web usando Laravel and Ajax.',
      'Proyecto personal enfocado al eCommerce con funciones para gestionar el carrito de compras y calificacion de producto',
    ],
    link: {
      href: 'https://sneakerstm.000webhostapp.com',
      isDisabled: false,
      textLink: 'www.sneakerstm.000webhostapp.com',
    },
  },
  {
    id: 3,
    image: {
      src: '/companies/simple-legal.jpg',
      alt: 'SimpleLegal',
    },
    description: [
      'Aplicación de una sola página usando ReactJS.',
      'Kit Firebase para base de datos en tiempo real, autenticación y funciones en la nube.'
    ],
    link: {
      href: '',
      isDisabled: true,
      textLink: '',
    },
  }
  /* {
    id: 4,
    image: {
      src: '/companies/ela-sustentable.png',
      alt: 'Ela Sustentable',
    },
    description: [
      'Single page application using ReactJS.',
      'Django & Django rest framework for Rest API.',
    ],
    link: {
      href: 'https://www.elasustentable.com',
      isDisabled: false,
      textLink: 'www.elsasustentable.com',
    },
  },
  {
    id: 5,
    image: {
      src: '/companies/colorbeats.png',
      alt: 'Colorbeats',
    },
    description: ['E-Commerce webpage using Shopify.'],
    link: {
      href: 'https://www.colorbeats.co',
      isDisabled: false,
      textLink: 'www.colorbeats.co',
    },
  },
  {
    id: 6,
    image: {
      src: '/companies/powerpay.png',
      alt: 'Powerpay',
    },
    description: [
      'Single page application using ReactJS.',
      'REST API developed using Ruby on Rails.',
    ],
    link: {
      href: 'https://www.getpowerpay.com',
      isDisabled: false,
      textLink: 'www.getpowerpay.com',
    },
  }, */
];

export default projects;
